import Banner from "../../utilities/Banner/Banner";
import { Container, Box } from "@mui/material";
import { Constants, TabEnum, DataTabs, ButtonType } from "../Content";
import TabPannel from "../../utilities/Tab/TabPannel";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ManageDataWrapper } from "./ManageDataStyled";
import SearchBoxSection from "../SearchBox/SearchBoxSection";
import TableTab from "../TableTab/TableTab";
import PricingModels from "../PricingModelsTab/PricingModels";
import ConfirmationBox from "../Popups/ConfirmationBox";
import DisplayTable from "../Tables/FilterTable";
import * as XLSX from "xlsx";
import { read, utils } from "xlsx";
import Loader from "../../utilities/Loader/Loader";
import Notification from "../../utilities/Notification/Notification";
import { Severity } from "../../utilities/Notification/NotificationContent";
import { isJsonString, toVariableNameFormat } from "../../../Helper/Helper";
import { LocalStorageKeys, PageName } from "../../QuoteRequest/Content";
import { useNavigate } from "react-router-dom";
import {
    getSessionUsageMasterData,
    saveStaffTimeMasterData,
    saveSessionUsageMasterData,
    saveStaffCostDeptMasterData,
    saveExternalCostsMasterData,
    saveOverheadCostsMasterData,
    saveRRCIAndTrainingMasterData,
    saveWebCostasterData,
    saveProductMarginMasterData,
    saveAdditionalCounselingPricingMasterData,
    savePathwaysPricingTableMasterData,
    saveGWQPricingMasterData,
    saveNPRTWPricingMasterData,
    saveCurrencyMasterData,
    saveServiceDistributionMasterData,
    saveEnhancedLandFAvailabilityMasterData,
    saveDeliveryStaffProductivityMasterData,
} from "../../../Actions/ManageDataAction";
import {
    remarkHeader,
    sessionUsageHeader,
    staffTimeHeaders,
    staffTimeErrorHeader,
    staffProductivityHeaders,
    staffCostDepartmentHeaders,
    serviceDistributionHeaders,
    overHeadCostHeaders,
    externalCostHeaders,
    webCostHeaders,
    marginTableHeaders,
    pricingModelsHeaders,
    rrciAndTrainingHeaders,
    additionalCounselingHeaders,
    pathWayHeaders,
    gwqHeaders,
    nprwtHeaders,
    currencyHeaders,
    enhancedLandFHeaders,
} from "../DummyData";
import { Congiguration } from "../../../Constants/AppConstants";
import { UserRole } from "../../QuoteRequest/Content";
import { getLoggedUserDetails } from "../../../Actions/UserAction";
import { GET_LOGGED_USER_DETAILS } from "../../../ActionTypes/ActionTypes";

const ManageData = () => {
    //#region Constant Variables
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [value, setValue] = useState("0");
    const tabContents = [];
    const [sessionRowData, setSessionRowData] = useState([]);
    const [serviceDistributionComponentHeader, setServiceDistributionComponentHeader] = useState([]);
    const [notificationMsg, setNotificationMsg] = useState("");
    const [showNotification, setShowNotification] = useState(false);
    const [showConfirmationBox, setShowConfirmationBox] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [uploadedFileType, setUploadedFileType] = useState(null);
    const [confirmationMessage, setConfirmationMessage] = useState("");
    const [notificationSeverity, setNotificationSeverity] = useState("");
    const [loadingState, setLoadingState] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [invalidData, setInvalidData] = useState([]);
    const [invalidHeader, setInvalidHeader] = useState([]);
    const [showInvalidDownload, setShowInvalidDownload] = useState(false);
    const [renderKey, setRenderKey] = useState(0);
    //const loggedUser = isJsonString(
    //    sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)
    //)
    //    ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER))
    //    : null;

    const useremail = sessionStorage.getItem(LocalStorageKeys.USEREMAIL);
    const loggedUserLocalStorage = isJsonString(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)) ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)) : null;


    let loggedUser = useSelector((state) => state?.UserReducer?.loggedUser);


    if (loggedUser !== undefined && Object.keys(loggedUser).length === 0 && loggedUser.constructor === Object && loggedUserLocalStorage !== null) {

        loggedUser = loggedUserLocalStorage;
        if (useremail?.toUpperCase() !== loggedUser?.user?.email?.toUpperCase()) {
            dispatch(getLoggedUserDetails(useremail))
                .then((response) => {
                    loggedUser = response;
                    //storing user login to reducer
                    dispatch({
                        type: GET_LOGGED_USER_DETAILS,
                        payload: response,
                    });
                })
                .catch((error) => {
                    console.log(`userEmail : ${useremail} error : ${error}`);
                });
        } else {
            //storing user login to reducer
            dispatch({
                type: GET_LOGGED_USER_DETAILS,
                payload: loggedUser,
            });
        }

    } else if (loggedUser !== undefined && Object.keys(loggedUser).length !== 0 && loggedUser.constructor === Object && loggedUserLocalStorage !== null) {
        loggedUser = loggedUserLocalStorage;
        if (useremail?.toUpperCase() !== loggedUser?.user?.email?.toUpperCase()) {
            dispatch(getLoggedUserDetails(useremail))
                .then((response) => {
                    loggedUser = response;
                    const jsonUserData = JSON.stringify(response);
                    sessionStorage.setItem(LocalStorageKeys.LOGGEDUSER, jsonUserData);
                    //storing user login to reducer
                    dispatch({
                        type: GET_LOGGED_USER_DETAILS,
                        payload: response,
                    });
                })
                .catch((error) => {
                    console.log(`userEmail : ${useremail} error : ${error}`);
                });
        }
    }
    //#endregion


    //#region Functions

    useEffect(() => {
        window.scrollTo(0, 0);
        sessionStorage.setItem(LocalStorageKeys.CURRENTPAGE, PageName.MANAGEDATAPAGE);
        if (loggedUser?.userRole[0]?.id !== UserRole.PRICINGTEAM && 
            loggedUser?.userRole[0]?.id !== UserRole.PRICINGMANAGER && 
            loggedUser?.userRole[0]?.id !== UserRole.PRICINGVP) {
            navigate("/pageNotfound", {
                state: {
                    status: Congiguration.unauthorizedStatus,
                },
            });
        } else {
            if (sessionStorage.getItem(LocalStorageKeys.MANAGEDATATAB) != undefined) {
                setValue(sessionStorage.getItem(LocalStorageKeys.MANAGEDATATAB));
            }
            else {
                sessionStorage.setItem(LocalStorageKeys.MANAGEDATATAB, value)
            }
            getAllMasterData();
        }
        document.title = "Manage Data";
    }, []);
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (loadingState) {
                event.preventDefault();
                event.returnValue = ''; // Standard for most browsers
                return 'An upload is in progress. Are you sure you want to leave?';
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [loadingState]);
    //   function useBlockNavigation(isUploading) {

    // }
    //#region Get Data
    function getAllMasterData() {
        try {
            GetSessionUsageMasterData();
        } catch (e) {
            console.log(e);
            setHasError(true);
            setLoadingState(false);
        }
    }
    function GetSessionUsageMasterData() {
        setLoadingState(true);
        try {
            dispatch(getSessionUsageMasterData())
                .then((data) => {
                    if (data?.length != null) {
                        setSessionRowData(data);
                    }
                    setLoadingState(false);
                })
                .catch((e) => {
                    console.log(e);
                    setLoadingState(false);
                });
        } catch (e) {
            console.log(e);
            setLoadingState(false);
            setHasError(true);
        }
    }

    //#endregion

    //#region Save Data
    function SaveSessionUsageMaster(uploadedData) {
        setLoadingState(true);
        if (uploadedData.length !== 0) {
            const sessionUsageObject = {
                companyId: Congiguration.CompanyId,
                listSessionUsageMasters: uploadedData,
                isBulkUpload: uploadedFileType === ButtonType.BULKUPLOAD,
                userId: loggedUser?.user?.id,
            };
            try {
                dispatch(saveSessionUsageMasterData(sessionUsageObject))
                    .then((data) => {
                        if (data && data?.result != -1) {
                            if (data?.result == 1) {
                                setNotificationMsg(Constants.UPLOADSUCCESSFUL);
                                setNotificationSeverity(Severity.SUCCESS);
                                setShowNotification(true);
                                setLoadingState(false);
                                setUploadedFileType(null);
                                setConfirmationMessage("");
                                GetSessionUsageMasterData();
                                setUploadedFile(null);
                            } else {
                                if (data.sessionUsageMasterErrors.length > 0) {
                                    setInvalidData(data?.sessionUsageMasterErrors);
                                    setInvalidHeader([...sessionUsageHeader, ...remarkHeader]);
                                    setShowInvalidDownload(true);
                                    setUploadedFileType(null);
                                    setUploadedFile(null);
                                    setLoadingState(false);
                                    setConfirmationMessage(Constants.REJCTDATAERROR);
                                    setShowConfirmationBox(true);
                                }
                            }

                            setLoadingState(false);
                        } else {
                            setLoadingState(false);
                            setNotificationMsg(Constants.FAILED);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                            setLoadingState(false);
                            setUploadedFileType(null);
                            setConfirmationMessage("");
                            setUploadedFile(null);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setLoadingState(false);
                        setNotificationMsg(Constants.FAILED);
                        setNotificationSeverity(Severity.ERROR);
                        setShowNotification(true);
                        setLoadingState(false);
                        setUploadedFileType(null);
                        setConfirmationMessage("");
                        setUploadedFile(null);
                    });
            } catch (e) {
                console.log(e);
                setLoadingState(false);
                setNotificationMsg(Constants.FAILED);
                setNotificationSeverity(Severity.ERROR);
                setShowNotification(true);
                setLoadingState(false);
                setUploadedFileType(null);
                setConfirmationMessage("");
                setUploadedFile(null);
            }
        } else {
            setUploadedFileType(null);
            setUploadedFile(null);
            setLoadingState(false);
            setNotificationMsg(Constants.EMPTYFILEERROR);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        }
    }
    function SaveStaffTimeMasterData(uploadedData) {
        setLoadingState(true);
        if (uploadedData.length !== 0) {
            const staffTime = {
                companyId: Congiguration.CompanyId,
                isBulkUpload: uploadedFileType === ButtonType.BULKUPLOAD,
                userId: loggedUser?.user?.id,
                listStaffTimeMasters: uploadedData,
            };
            try {
                dispatch(saveStaffTimeMasterData(staffTime))
                    .then((data) => {
                        if (data && data?.result != -1) {
                            if (data?.result == 1) {
                                setRenderKey((prevKey) => prevKey + 1);
                                setNotificationMsg(Constants.UPLOADSUCCESSFUL);
                                setNotificationSeverity(Severity.SUCCESS);
                                setShowNotification(true);
                                setLoadingState(false);
                                setUploadedFileType(null);
                                setConfirmationMessage("");
                                setUploadedFile(null);
                            } else {
                                if (data?.staffTimeMasterErrors?.length > 0) {
                                    setInvalidData(data?.staffTimeMasterErrors);
                                    setInvalidHeader([...staffTimeHeaders, ...remarkHeader]);
                                    setShowInvalidDownload(true);
                                    setUploadedFileType(null);
                                    setUploadedFile(null);
                                    setLoadingState(false);
                                    setConfirmationMessage(Constants.REJCTDATAERROR);
                                    setShowConfirmationBox(true);
                                }
                            }
                            setRenderKey((prevKey) => prevKey + 1);
                            setLoadingState(false);
                        } else {
                            setLoadingState(false);
                            setNotificationMsg(Constants.FAILED);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                            setLoadingState(false);
                            setUploadedFileType(null);
                            setConfirmationMessage("");
                            setUploadedFile(null);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setLoadingState(false);
                        setNotificationMsg(Constants.FAILED);
                        setNotificationSeverity(Severity.ERROR);
                        setShowNotification(true);
                        setLoadingState(false);
                        setUploadedFileType(null);
                        setConfirmationMessage("");
                        setUploadedFile(null);
                    });
            } catch (e) {
                console.log(e);
                setLoadingState(false);
                setHasError(true);
                setNotificationMsg(Constants.FAILED);
                setNotificationSeverity(Severity.ERROR);
                setShowNotification(true);
                setLoadingState(false);
                setUploadedFileType(null);
                setConfirmationMessage("");
                setUploadedFile(null);
            }
        } else {
            setUploadedFileType(null);
            setUploadedFile(null);
            setLoadingState(false);
            setNotificationMsg(Constants.EMPTYFILEERROR);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        }
    }
    function SaveStaffProductivityMasterData(uploadedData) {
        setLoadingState(true);

        if (uploadedData.length !== 0) {
            const DeliveryStaffProductivityMasters = {
                companyId: Congiguration.CompanyId,
                isBulkUpload: uploadedFileType === ButtonType.BULKUPLOAD,
                userId: loggedUser?.user?.id,
                listDeliveryStaffProductivityMasters: uploadedData,
            };
            try {
                dispatch(
                    saveDeliveryStaffProductivityMasterData(
                        DeliveryStaffProductivityMasters
                    )
                )
                    .then((data) => {
                        if (data != null && data?.result != -1) {
                            if (data?.result == 1) {
                                setNotificationMsg(Constants.UPLOADSUCCESSFUL);
                                setNotificationSeverity(Severity.SUCCESS);
                                setShowNotification(true);
                                setLoadingState(false);
                                setUploadedFileType(null);
                                setConfirmationMessage("");
                                setUploadedFile(null);
                            } else {
                                if (
                                    data?.deliveryStaffProductivityMasterMasterErrors?.length > 0
                                ) {
                                    setInvalidData(
                                        data?.deliveryStaffProductivityMasterMasterErrors
                                    );
                                    setInvalidHeader([
                                        ...staffProductivityHeaders,
                                        ...remarkHeader,
                                    ]);
                                    setShowInvalidDownload(true);
                                    setUploadedFileType(null);
                                    setUploadedFile(null);
                                    setLoadingState(false);
                                    setConfirmationMessage(Constants.REJCTDATAERROR);
                                    setShowConfirmationBox(true);
                                }
                            }
                            setRenderKey((prevKey) => prevKey + 1);
                            setLoadingState(false);
                        } else {
                            setNotificationMsg(Constants.FAILED);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                            setLoadingState(false);
                            setUploadedFileType(null);
                            setConfirmationMessage("");
                            setUploadedFile(null);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setLoadingState(false);
                        setNotificationMsg(Constants.FAILED);
                        setNotificationSeverity(Severity.ERROR);
                        setShowNotification(true);
                        setLoadingState(false);
                        setUploadedFileType(null);
                        setConfirmationMessage("");
                        setUploadedFile(null);
                    });
            } catch (e) {
                console.log(e);
                setLoadingState(false);
                setHasError(true);
                setNotificationMsg(Constants.FAILED);
                setNotificationSeverity(Severity.ERROR);
                setShowNotification(true);
                setLoadingState(false);
                setUploadedFileType(null);
                setConfirmationMessage("");
                setUploadedFile(null);
            }
        } else {
            setUploadedFileType(null);
            setUploadedFile(null);
            setLoadingState(false);
            setNotificationMsg(Constants.EMPTYFILEERROR);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        }
    }
    function SaveStaffCostDepartmentMasterData(uploadedData) {
        setLoadingState(true);
        if (uploadedData.length !== 0) {
            const staffCostDepartment = {
                companyId: Congiguration.CompanyId,
                isBulkUpload: uploadedFileType === ButtonType.BULKUPLOAD,
                userId: loggedUser?.user?.id,
                listStaffCostDepartmentMasters: uploadedData,
            };
            try {
                dispatch(saveStaffCostDeptMasterData(staffCostDepartment))
                    .then((data) => {
                        if (data != null && data?.result != -1) {
                            if (data?.result == 1) {
                                setNotificationMsg(Constants.UPLOADSUCCESSFUL);
                                setNotificationSeverity(Severity.SUCCESS);
                                setShowNotification(true);
                                setLoadingState(false);
                                setUploadedFileType(null);
                                setConfirmationMessage("");
                                setUploadedFile(null);
                            } else {
                                if (data?.staffCostDepartmentMasterErrors?.length > 0) {
                                    setInvalidData(data?.staffCostDepartmentMasterErrors);
                                    setInvalidHeader([
                                        ...staffCostDepartmentHeaders,
                                        ...remarkHeader,
                                    ]);
                                    setShowInvalidDownload(true);
                                    setUploadedFileType(null);
                                    setUploadedFile(null);
                                    setLoadingState(false);
                                    setConfirmationMessage(Constants.REJCTDATAERROR);
                                    setShowConfirmationBox(true);
                                }
                            }
                            setRenderKey((prevKey) => prevKey + 1);
                            setLoadingState(false);
                        } else {
                            setNotificationMsg(Constants.FAILED);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                            setLoadingState(false);
                            setUploadedFileType(null);
                            setConfirmationMessage("");
                            setUploadedFile(null);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setNotificationMsg(Constants.FAILED);
                        setNotificationSeverity(Severity.ERROR);
                        setShowNotification(true);
                        setLoadingState(false);
                        setUploadedFileType(null);
                        setConfirmationMessage("");
                        setUploadedFile(null);
                    });
            } catch (e) {
                console.log(e);
                setLoadingState(false);
                setHasError(true);
            }
        } else {
            setUploadedFileType(null);
            setUploadedFile(null);
            setLoadingState(false);
            setNotificationMsg(Constants.EMPTYFILEERROR);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        }
    }
    function SaveExternalCostsMasterData(uploadedData) {
        setLoadingState(true);
        if (uploadedData.length !== 0) {
            const externalCosts = {
                companyId: Congiguration.CompanyId,
                isBulkUpload: uploadedFileType === ButtonType.BULKUPLOAD,
                userId: loggedUser?.user?.id,
                listExternalCostsMasters: uploadedData,
            };
            try {
                dispatch(saveExternalCostsMasterData(externalCosts))
                    .then((data) => {
                        if (data != null && data?.result != -1) {
                            if (data?.result == 1) {
                                setNotificationMsg(Constants.UPLOADSUCCESSFUL);
                                setNotificationSeverity(Severity.SUCCESS);
                                setShowNotification(true);
                                setLoadingState(false);
                                setUploadedFileType(null);
                                setConfirmationMessage("");
                                setUploadedFile(null);
                            } else {
                                if (data?.externalCostsMasterErrors?.length > 0) {
                                    setInvalidData(data?.externalCostsMasterErrors);
                                    setInvalidHeader([...externalCostHeaders, ...remarkHeader]);
                                    setShowInvalidDownload(true);
                                    setUploadedFileType(null);
                                    setUploadedFile(null);
                                    setLoadingState(false);
                                    setConfirmationMessage(Constants.REJCTDATAERROR);
                                    setShowConfirmationBox(true);
                                }
                            }
                            setRenderKey((prevKey) => prevKey + 1);
                            setLoadingState(false);
                        } else {
                            setNotificationMsg(Constants.FAILED);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                            setLoadingState(false);
                            setUploadedFileType(null);
                            setConfirmationMessage("");
                            setUploadedFile(null);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setLoadingState(false);
                        setNotificationMsg(Constants.FAILED);
                        setNotificationSeverity(Severity.ERROR);
                        setShowNotification(true);
                        setLoadingState(false);
                        setUploadedFileType(null);
                        setConfirmationMessage("");
                        setUploadedFile(null);
                    });
            } catch (e) {
                console.log(e);
                setLoadingState(false);
                setHasError(true);
            }
        } else {
            setUploadedFileType(null);
            setUploadedFile(null);
            setLoadingState(false);
            setNotificationMsg(Constants.EMPTYFILEERROR);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        }
    }
    function SaveOverHeadCostsMasterData(uploadedData) {
        setLoadingState(true);
        if (uploadedData.length !== 0) {
            const OverheadCosts = {
                companyId: Congiguration.CompanyId,
                isBulkUpload: uploadedFileType === ButtonType.BULKUPLOAD,
                userId: loggedUser?.user?.id,
                listOverheadCosts: uploadedData,
            };
            try {
                dispatch(saveOverheadCostsMasterData(OverheadCosts))
                    .then((data) => {
                        if (data != null && data?.result != -1) {
                            if (data?.result == 1) {
                                setNotificationMsg(Constants.UPLOADSUCCESSFUL);
                                setNotificationSeverity(Severity.SUCCESS);
                                setShowNotification(true);
                                setLoadingState(false);
                                setUploadedFileType(null);
                                setConfirmationMessage("");
                                setUploadedFile(null);
                            } else {
                                if (data?.overheadCostsMasterErrors?.length > 0) {
                                    setInvalidData(data?.overheadCostsMasterErrors);
                                    setInvalidHeader([...overHeadCostHeaders, ...remarkHeader]);
                                    setShowInvalidDownload(true);
                                    setUploadedFileType(null);
                                    setUploadedFile(null);
                                    setLoadingState(false);
                                    setConfirmationMessage(Constants.REJCTDATAERROR);
                                    setShowConfirmationBox(true);
                                }
                            }
                            setRenderKey((prevKey) => prevKey + 1);
                            setLoadingState(false);
                        } else {
                            setNotificationMsg(Constants.FAILED);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                            setLoadingState(false);
                            setUploadedFileType(null);
                            setConfirmationMessage("");
                            setUploadedFile(null);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setLoadingState(false);
                    });
            } catch (e) {
                console.log(e);
                setLoadingState(false);
                setHasError(true);
            }
        } else {
            setUploadedFileType(null);
            setUploadedFile(null);
            setLoadingState(false);
            setNotificationMsg(Constants.EMPTYFILEERROR);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        }
    }
    function SaveWebCostMasterData(uploadedData) {
        setLoadingState(true);
        if (uploadedData.length !== 0) {
            const WebCost = {
                companyId: Congiguration.CompanyId,
                isBulkUpload: uploadedFileType === ButtonType.BULKUPLOAD,
                userId: loggedUser?.user?.id,
                listWebCosts: uploadedData,
            };
            try {
                dispatch(saveWebCostasterData(WebCost))
                    .then((data) => {
                        if (data != null && data?.result != -1) {
                            if (data?.result == 1) {
                                setNotificationMsg(Constants.UPLOADSUCCESSFUL);
                                setNotificationSeverity(Severity.SUCCESS);
                                setShowNotification(true);
                                setLoadingState(false);
                                setUploadedFileType(null);
                                setConfirmationMessage("");
                                setUploadedFile(null);
                            } else {
                                if (data?.webCostsMasterErrors?.length > 0) {
                                    setInvalidData(data?.webCostsMasterErrors);
                                    setInvalidHeader([...webCostHeaders, ...remarkHeader]);
                                    setShowInvalidDownload(true);
                                    setUploadedFileType(null);
                                    setUploadedFile(null);
                                    setLoadingState(false);
                                    setConfirmationMessage(Constants.REJCTDATAERROR);
                                    setShowConfirmationBox(true);
                                }
                            }
                            setRenderKey((prevKey) => prevKey + 1);
                            setLoadingState(false);
                        } else {
                            setNotificationMsg(Constants.FAILED);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                            setLoadingState(false);
                            setUploadedFileType(null);
                            setConfirmationMessage("");
                            setUploadedFile(null);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setLoadingState(false);
                    });
            } catch (e) {
                console.log(e);
                setLoadingState(false);
                setHasError(true);
            }
        } else {
            setUploadedFileType(null);
            setUploadedFile(null);
            setLoadingState(false);
            setNotificationMsg(Constants.EMPTYFILEERROR);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        }
    }
    function SaveProductMarginMasterData(uploadedData) {
        setLoadingState(true);
        if (uploadedData.length !== 0) {
            const ProductMargin = {
                companyId: Congiguration.CompanyId,
                isBulkUpload: uploadedFileType === ButtonType.BULKUPLOAD,
                userId: loggedUser?.user?.id,
                listProductMarginMaster: uploadedData,
            };
            try {
                dispatch(saveProductMarginMasterData(ProductMargin))
                    .then((data) => {
                        if (data != null && data?.result != -1) {
                            if (data?.result == 1) {
                                setNotificationMsg(Constants.UPLOADSUCCESSFUL);
                                setNotificationSeverity(Severity.SUCCESS);
                                setShowNotification(true);
                                setLoadingState(false);
                                setUploadedFileType(null);
                                setConfirmationMessage("");
                                setUploadedFile(null);
                            } else {
                                if (data?.productMarginMasterErrors?.length > 0) {
                                    setInvalidData(data?.productMarginMasterErrors);
                                    setInvalidHeader([...marginTableHeaders, ...remarkHeader]);
                                    setShowInvalidDownload(true);
                                    setUploadedFileType(null);
                                    setUploadedFile(null);
                                    setLoadingState(false);
                                    setConfirmationMessage(Constants.REJCTDATAERROR);
                                    setShowConfirmationBox(true);
                                }
                            }
                            setRenderKey((prevKey) => prevKey + 1);
                            setLoadingState(false);
                        } else {
                            setNotificationMsg(Constants.FAILED);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                            setLoadingState(false);
                            setUploadedFileType(null);
                            setConfirmationMessage("");
                            setUploadedFile(null);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setLoadingState(false);
                    });
            } catch (e) {
                console.log(e);
                setLoadingState(false);
                setHasError(true);
            }
        } else {
            setUploadedFileType(null);
            setUploadedFile(null);
            setLoadingState(false);
            setNotificationMsg(Constants.EMPTYFILEERROR);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        }
    }
    function SaveRricAndTrainingMasterData(uploadedData) {
        setLoadingState(true);
        if (uploadedData.length !== 0) {
            const rRCIAndTrainingMasterData = {
                companyId: Congiguration.CompanyId,
                isBulkUpload: uploadedFileType === ButtonType.BULKUPLOAD,
                userId: loggedUser?.user?.id,
                listRRCIAndTrainingPricing: uploadedData,
            };
            try {
                dispatch(saveRRCIAndTrainingMasterData(rRCIAndTrainingMasterData))
                    .then((data) => {
                        if (data != null && data?.result != -1) {
                            if (data?.result == 1) {
                                setNotificationMsg(Constants.UPLOADSUCCESSFUL);
                                setNotificationSeverity(Severity.SUCCESS);
                                setShowNotification(true);
                                setLoadingState(false);
                                setUploadedFileType(null);
                                setConfirmationMessage("");
                                setUploadedFile(null);
                            } else {
                                if (data?.rrciAndTrainingPricingMasterErrors?.length > 0) {
                                    setInvalidData(data?.rrciAndTrainingPricingMasterErrors);
                                    setInvalidHeader([
                                        ...rrciAndTrainingHeaders,
                                        ...remarkHeader,
                                    ]);
                                    setShowInvalidDownload(true);
                                    setUploadedFileType(null);
                                    setUploadedFile(null);
                                    setLoadingState(false);
                                    setConfirmationMessage(Constants.REJCTDATAERROR);
                                    setShowConfirmationBox(true);
                                }
                            }
                            setRenderKey((prevKey) => prevKey + 1);
                            setLoadingState(false);
                        } else {
                            setNotificationMsg(Constants.FAILED);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                            setLoadingState(false);
                            setUploadedFileType(null);
                            setConfirmationMessage("");
                            setUploadedFile(null);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setLoadingState(false);
                    });
            } catch (e) {
                console.log(e);
                setLoadingState(false);
                setHasError(true);
            }
        } else {
            setUploadedFileType(null);
            setUploadedFile(null);
            setLoadingState(false);
            setNotificationMsg(Constants.EMPTYFILEERROR);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        }
    }
    function SaveAdditionalCounselingMasterData(uploadedData) {
        setLoadingState(true);
        if (uploadedData.length !== 0) {
            const additionalCounselingPricing = {
                companyId: Congiguration.CompanyId,
                isBulkUpload: uploadedFileType === ButtonType.BULKUPLOAD,
                userId: loggedUser?.user?.id,
                listAdditionalCounselingPricing: uploadedData,
            };
            try {
                dispatch(
                    saveAdditionalCounselingPricingMasterData(additionalCounselingPricing)
                )
                    .then((data) => {
                        if (data != null && data?.result != -1) {
                            if (data?.result == 1) {
                                setNotificationMsg(Constants.UPLOADSUCCESSFUL);
                                setNotificationSeverity(Severity.SUCCESS);
                                setShowNotification(true);
                                setLoadingState(false);
                                setUploadedFileType(null);
                                setConfirmationMessage("");
                                setUploadedFile(null);
                            } else {
                                if (data?.additionalCounselingPricingMasterErrors?.length > 0) {
                                    setInvalidData(data?.additionalCounselingPricingMasterErrors);
                                    setInvalidHeader([
                                        ...additionalCounselingHeaders,
                                        ...remarkHeader,
                                    ]);
                                    setShowInvalidDownload(true);
                                    setUploadedFileType(null);
                                    setUploadedFile(null);
                                    setLoadingState(false);
                                    setConfirmationMessage(Constants.REJCTDATAERROR);
                                    setShowConfirmationBox(true);
                                }
                            }
                            setRenderKey((prevKey) => prevKey + 1);
                            setLoadingState(false);
                        } else {
                            setNotificationMsg(Constants.FAILED);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                            setLoadingState(false);
                            setUploadedFileType(null);
                            setConfirmationMessage("");
                            setUploadedFile(null);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setLoadingState(false);
                    });
            } catch (e) {
                console.log(e);
                setLoadingState(false);
                setHasError(true);
            }
        } else {
            setUploadedFileType(null);
            setUploadedFile(null);
            setLoadingState(false);
            setNotificationMsg(Constants.EMPTYFILEERROR);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        }
    }
    function SavePathwayMasterData(uploadedData) {
        setLoadingState(true);
        if (uploadedData.length !== 0) {
            const PathwaysPricing = {
                companyId: Congiguration.CompanyId,
                isBulkUpload: uploadedFileType === ButtonType.BULKUPLOAD,
                userId: loggedUser?.user?.id,
                listPathwaysPricing: uploadedData,
            };
            try {
                dispatch(savePathwaysPricingTableMasterData(PathwaysPricing))
                    .then((data) => {
                        if (data != null && data?.result != -1) {
                            if (data?.result == 1) {
                                setNotificationMsg(Constants.UPLOADSUCCESSFUL);
                                setNotificationSeverity(Severity.SUCCESS);
                                setShowNotification(true);
                                setLoadingState(false);
                                setUploadedFileType(null);
                                setConfirmationMessage("");
                                setUploadedFile(null);
                            } else {
                                if (data?.pathwaysPricingMasterErrors?.length > 0) {
                                    setInvalidData(data?.pathwaysPricingMasterErrors);
                                    setInvalidHeader([...pathWayHeaders, ...remarkHeader]);
                                    setShowInvalidDownload(true);
                                    setUploadedFileType(null);
                                    setUploadedFile(null);
                                    setLoadingState(false);
                                    setConfirmationMessage(Constants.REJCTDATAERROR);
                                    setShowConfirmationBox(true);
                                }
                            }
                            setRenderKey((prevKey) => prevKey + 1);
                            setLoadingState(false);
                        } else {
                            setNotificationMsg(Constants.FAILED);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                            setLoadingState(false);
                            setUploadedFileType(null);
                            setConfirmationMessage("");
                            setUploadedFile(null);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setLoadingState(false);
                    });
            } catch (e) {
                console.log(e);
                setLoadingState(false);
                setHasError(true);
            }
        } else {
            setUploadedFileType(null);
            setUploadedFile(null);
            setLoadingState(false);
            setNotificationMsg(Constants.EMPTYFILEERROR);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        }
    }
    function SaveGwqMasterData(uploadedData) {
        setLoadingState(true);
        if (uploadedData.length !== 0) {
            const gWQPricing = {
                companyId: Congiguration.CompanyId,
                isBulkUpload: uploadedFileType === ButtonType.BULKUPLOAD,
                userId: loggedUser?.user?.id,
                listGWQPricing: uploadedData,
            };
            try {
                dispatch(saveGWQPricingMasterData(gWQPricing))
                    .then((data) => {
                        if (data != null && data?.result != -1) {
                            if (data?.result == 1) {
                                setNotificationMsg(Constants.UPLOADSUCCESSFUL);
                                setNotificationSeverity(Severity.SUCCESS);
                                setShowNotification(true);
                                setLoadingState(false);
                                setUploadedFileType(null);
                                setConfirmationMessage("");
                                setUploadedFile(null);
                            } else {
                                if (data?.gwqPricingMasterErrors?.length > 0) {
                                    setInvalidData(data?.gwqPricingMasterErrors);
                                    setInvalidHeader([...gwqHeaders, ...remarkHeader]);
                                    setShowInvalidDownload(true);
                                    setUploadedFileType(null);
                                    setUploadedFile(null);
                                    setLoadingState(false);
                                    setConfirmationMessage(Constants.REJCTDATAERROR);
                                    setShowConfirmationBox(true);
                                }
                            }
                            setRenderKey((prevKey) => prevKey + 1);
                            setLoadingState(false);
                        } else {
                            setNotificationMsg(Constants.FAILED);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                            setLoadingState(false);
                            setUploadedFileType(null);
                            setConfirmationMessage("");
                            setUploadedFile(null);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setLoadingState(false);
                    });
            } catch (e) {
                console.log(e);
                setLoadingState(false);
                setHasError(true);
            }
        } else {
            setUploadedFileType(null);
            setUploadedFile(null);
            setLoadingState(false);
            setNotificationMsg(Constants.EMPTYFILEERROR);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        }
    }
    function SaveNprtwMasterData(uploadedData) {
        setLoadingState(true);
        if (uploadedData.length !== 0) {
            const nprtwPricing = {
                companyId: Congiguration.CompanyId,
                isBulkUpload: uploadedFileType === ButtonType.BULKUPLOAD,
                userId: loggedUser?.user?.id,
                ListNPRTWPricing: uploadedData,
            };
            try {
                dispatch(saveNPRTWPricingMasterData(nprtwPricing))
                    .then((data) => {
                        if (data != null && data?.result != -1) {
                            if (data?.result == 1) {
                                setNotificationMsg(Constants.UPLOADSUCCESSFUL);
                                setNotificationSeverity(Severity.SUCCESS);
                                setShowNotification(true);
                                setLoadingState(false);
                                setUploadedFileType(null);
                                setConfirmationMessage("");
                                setUploadedFile(null);
                            } else {
                                if (data?.nprtwPricingMasterErrors?.length > 0) {
                                    setInvalidData(data?.nprtwPricingMasterErrors);
                                    setInvalidHeader([...nprwtHeaders, ...remarkHeader]);
                                    setShowInvalidDownload(true);
                                    setUploadedFileType(null);
                                    setUploadedFile(null);
                                    setLoadingState(false);
                                    setConfirmationMessage(Constants.REJCTDATAERROR);
                                    setShowConfirmationBox(true);
                                }
                            }
                            setRenderKey((prevKey) => prevKey + 1);
                            setLoadingState(false);
                        } else {
                            setNotificationMsg(Constants.FAILED);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                            setLoadingState(false);
                            setUploadedFileType(null);
                            setConfirmationMessage("");
                            setUploadedFile(null);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setLoadingState(false);
                    });
            } catch (e) {
                console.log(e);
                setLoadingState(false);
                setHasError(true);
            }
        } else {
            setUploadedFileType(null);
            setUploadedFile(null);
            setLoadingState(false);
            setNotificationMsg(Constants.EMPTYFILEERROR);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        }
    }
    function SaveCurrencyMasterData(uploadedData) {
        setLoadingState(true);
        if (uploadedData.length !== 0) {
            const currencyMaster = {
                companyId: Congiguration.CompanyId,
                isBulkUpload: uploadedFileType === ButtonType.BULKUPLOAD,
                userId: loggedUser?.user?.id,
                listCurrencyConversion: uploadedData,
            };
            try {
                dispatch(saveCurrencyMasterData(currencyMaster))
                    .then((data) => {
                        if (data != null && data?.result != -1) {
                            if (data?.result == 1) {
                                setNotificationMsg(Constants.UPLOADSUCCESSFUL);
                                setNotificationSeverity(Severity.SUCCESS);
                                setShowNotification(true);
                                setLoadingState(false);
                                setUploadedFileType(null);
                                setConfirmationMessage("");
                                setUploadedFile(null);
                            } else {
                                if (data?.currencyConversionMasterErrors?.length > 0) {
                                    setInvalidData(data?.currencyConversionMasterErrors);
                                    setInvalidHeader([...currencyHeaders, ...remarkHeader]);
                                    setShowInvalidDownload(true);
                                    setUploadedFileType(null);
                                    setUploadedFile(null);
                                    setLoadingState(false);
                                    setConfirmationMessage(Constants.REJCTDATAERROR);
                                    setShowConfirmationBox(true);
                                }
                            }
                            setRenderKey((prevKey) => prevKey + 1);
                            setLoadingState(false);
                        } else {
                            setNotificationMsg(Constants.FAILED);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                            setLoadingState(false);
                            setUploadedFileType(null);
                            setConfirmationMessage("");
                            setUploadedFile(null);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setLoadingState(false);
                    });
            } catch (e) {
                console.log(e);
                setLoadingState(false);
                setHasError(true);
            }
        } else {
            setUploadedFileType(null);
            setUploadedFile(null);
            setLoadingState(false);
            setNotificationMsg(Constants.EMPTYFILEERROR);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        }
    }
    function SaveServiceDistributionMasterData(uploadedData, headerValues) {

        setLoadingState(true);
        if (uploadedData.length !== 0) {
            const serviceDistribution = {
                companyId: Congiguration.CompanyId,
                isBulkUpload: uploadedFileType === ButtonType.BULKUPLOAD,
                userId: loggedUser?.user?.id,
                listServiceDistributionMaster: uploadedData,
            };

            try {
                dispatch(saveServiceDistributionMasterData(serviceDistribution))
                    .then((data) => {
                        if (data != null && data?.result != -1) {
                            if (data?.result == 1) {
                                setNotificationMsg(Constants.UPLOADSUCCESSFUL);
                                setNotificationSeverity(Severity.SUCCESS);
                                setShowNotification(true);
                                setLoadingState(false);
                                setUploadedFileType(null);
                                setConfirmationMessage("");
                                setUploadedFile(null);
                            } else {
                                if (data?.serviceDistributionMasterErrors?.length > 0) {

                                    setInvalidData(data?.serviceDistributionMasterErrors);
                                    setInvalidHeader([...headerValues, ...remarkHeader]);
                                    setShowInvalidDownload(true);
                                    setUploadedFileType(null);
                                    setUploadedFile(null);
                                    setLoadingState(false);
                                    setConfirmationMessage(Constants.REJCTDATAERROR);
                                    setShowConfirmationBox(true);
                                }
                            }
                            setRenderKey((prevKey) => prevKey + 1);
                            setLoadingState(false);
                        } else {
                            setNotificationMsg(Constants.FAILED);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                            setLoadingState(false);
                            setUploadedFileType(null);
                            setConfirmationMessage("");
                            setUploadedFile(null);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setLoadingState(false);
                    });
            } catch (e) {
                console.log(e);
                setLoadingState(false);
                setHasError(true);
            }
        } else {
            setUploadedFileType(null);
            setUploadedFile(null);
            setLoadingState(false);
            setNotificationMsg(Constants.EMPTYFILEERROR);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        }
    }
    function SaveEnhancedLandFAvailabilityMasterData(uploadedData) {
        setLoadingState(true);
        if (uploadedData.length !== 0) {
            const enhancedLFMaster = {
                companyId: Congiguration.CompanyId,
                isBulkUpload: uploadedFileType === ButtonType.BULKUPLOAD,
                userId: loggedUser?.user?.id,
                listEnhancedLFMaster: uploadedData,
            };
            try {
                dispatch(saveEnhancedLandFAvailabilityMasterData(enhancedLFMaster))
                    .then((data) => {
                        if (data != null && data?.result != -1) {
                            if (data?.result == 1) {
                                setNotificationMsg(Constants.UPLOADSUCCESSFUL);
                                setNotificationSeverity(Severity.SUCCESS);
                                setShowNotification(true);
                                setLoadingState(false);
                                setUploadedFileType(null);
                                setConfirmationMessage("");
                                setUploadedFile(null);
                            } else {
                                if (data?.enhancedLFMasterErrors?.length > 0) {
                                    setInvalidData(data?.enhancedLFMasterErrors);
                                    setInvalidHeader([...enhancedLandFHeaders, ...remarkHeader]);
                                    setShowInvalidDownload(true);
                                    setUploadedFileType(null);
                                    setUploadedFile(null);
                                    setLoadingState(false);
                                    setConfirmationMessage(Constants.REJCTDATAERROR);
                                    setShowConfirmationBox(true);
                                }
                            }
                            setRenderKey((prevKey) => prevKey + 1);
                            setLoadingState(false);
                        } else {
                            setNotificationMsg(Constants.FAILED);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                            setLoadingState(false);
                            setUploadedFileType(null);
                            setConfirmationMessage("");
                            setUploadedFile(null);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setLoadingState(false);
                    });
            } catch (e) {
                console.log(e);
                setLoadingState(false);
                setHasError(true);
            }
        } else {
            setUploadedFileType(null);
            setUploadedFile(null);
            setLoadingState(false);
            setNotificationMsg(Constants.EMPTYFILEERROR);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        }
    }
    //#endregion
    const handleChange = (event, newValue) => {
        setValue(newValue);
        console.log(renderKey);
        sessionStorage.setItem(LocalStorageKeys.MANAGEDATATAB, newValue);
        setRenderKey(parseInt(newValue));
        switch (newValue) {
            case TabEnum.SESSIONUSAGEPERCASE:
                setSessionRowData(sessionRowData);
            default:
                break;
        }
    };
    const closeNotificationPopup = () => {
        setShowNotification(false);
    };
    const handleTemplateDownload = (e) => {
        const table = document.getElementById("datatable");
        const tableCopy = table.cloneNode(true);
        const tbodyCopy = tableCopy.querySelector("tbody");
        if (tbodyCopy) {
            tbodyCopy.innerHTML = "";
        }
        const ws = XLSX.utils.table_to_sheet(tableCopy);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, Constants.SHEETNAME);
        XLSX.writeFile(wb, `${DataTabs[value]}.xlsx`);
    };
    const handleFileDownload = (e, dataArray, headerArray) => {
        const data = dataArray.map((row) => {
            const rowData = {};
            headerArray.forEach((header) => {
                if (row.hasOwnProperty(header.id)) {
                    rowData[header.header] = row[header.id] === undefined || row[header.id] === null ? "" : isNaN(row[header.id]) ? row[header.id] : `${header?.showdecimals ? Number(row[header.id])?.toLocaleString("en", { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 6 })?.trim() : row[header.id]?.toLocaleString()?.trim()}${header?.percentage ? '%' : ''}`;
                }
            });
            return rowData;
        });
        if (value === TabEnum.PRODUCTPRICINGMODELS) {
            data.map((x) => {
                headerArray.forEach((header) => {
                    x[header.header] =
                        x[header.header] === 'true'
                            ? "X"
                            : x[header.header] === 'false'
                                ? ""
                                : x[header.header];
                });
            });
        }
        const table = document.getElementById("datatable");
        const tableCopy = table.cloneNode(true);
        const tbodyCopy = tableCopy.querySelector("tbody");
        if (tbodyCopy) {
            tbodyCopy.innerHTML = "";
        }
        const ws =
            data?.length === 0
                ? XLSX.utils.table_to_sheet(tableCopy)
                : XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, Constants.SHEETNAME);
        XLSX.writeFile(wb, `${DataTabs[value]}.xlsx`);
    };
    const handleRejectedListDownload = (e) => {
        if (showInvalidDownload) {
            const data = invalidData.map((row) => {
                const rowData = {};
                invalidHeader.forEach((header) => {
                    if (row.hasOwnProperty(header.id)) {
                        rowData[header.header] = row[header.id];
                    } else {
                        rowData[header.header] = "";
                    }
                });
                return rowData;
            });
            const ws = XLSX.utils.json_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, Constants.SheetNames);
            XLSX.writeFile(wb, `${DataTabs[value]}.xlsx`);
        }
        setConfirmationMessage("");
        setShowConfirmationBox(false);
        setShowInvalidDownload(false);
    };
    const closeConfirmationBox = () => {
        setShowConfirmationBox(false);
        setShowInvalidDownload(false);
    };
    const handleConfirmUpload = (e, type, headers) => {
        setUploadedFile(e.target.files[0]);
        setUploadedFileType(type);
        e.target.value = null;
        setShowConfirmationBox(true);
        setConfirmationMessage(
            type === ButtonType.PARTIALUPLOAD
                ? Constants.PARTIALUPLOADCONFIRM
                : Constants.BULKUPLOADCONFIRM
        );
        if (value === TabEnum.SERVICEDISTRIBUTION) { setServiceDistributionComponentHeader(headers); }
    };
    const handleFileUpload = async (e, type) => {
        setLoadingState(true);
        setShowConfirmationBox(false);
        const file = uploadedFile != null ? uploadedFile : e.target.files[0];
        if (file) {
            if (file.name.endsWith(".xlsx")) {
                try {
                    const data = await file.arrayBuffer();
                    const wb = read(data);
                    const ws = wb.Sheets[wb.SheetNames[0]];

                    const filedata = utils.sheet_to_json(ws, { raw: false });
                    e.target.file = null;
                    if (filedata.length < 0) {
                        setNotificationMsg(Constants.EMPTYFILEERROR);
                        setNotificationSeverity(Severity.ERROR);
                        setShowNotification(true);
                        setLoadingState(false);
                    } else {
                        let objArr = [];
                        let headerValues = [];
                        switch (value) {
                            case TabEnum.SESSIONUSAGEPERCASE:
                                headerValues = sessionUsageHeader;
                                break;
                            case TabEnum.STAFFTIME:
                                headerValues = staffTimeHeaders;
                                break;
                            case TabEnum.STAFFPRODUCTIVITY:
                                headerValues = staffProductivityHeaders;
                                break;
                            case TabEnum.STAFFCOST:
                                headerValues = staffCostDepartmentHeaders;
                                break;
                            case TabEnum.SERVICEDISTRIBUTION:
                                headerValues = serviceDistributionComponentHeader;
                                break;
                            case TabEnum.EXTERNALCOST:
                                headerValues = externalCostHeaders;
                                break;
                            case TabEnum.OVERHEADCOST:
                                headerValues = overHeadCostHeaders;
                                break;
                            case TabEnum.WEBCOST:
                                headerValues = webCostHeaders;
                                break;
                            case TabEnum.MARGINTABLE:
                                headerValues = marginTableHeaders;
                                break;
                            case TabEnum.RRCIANDTRAININGPRICING:
                                headerValues = rrciAndTrainingHeaders;
                                break;
                            case TabEnum.ADDITIONALCOUNSELINGPRICING:
                                headerValues = additionalCounselingHeaders;
                                break;
                            case TabEnum.PATHWAYSPRICING:
                                headerValues = pathWayHeaders;
                                break;
                            case TabEnum.GWQPRICING:
                                headerValues = gwqHeaders;
                                break;
                            case TabEnum.NPRTWPRICING:
                                headerValues = nprwtHeaders;
                                break;
                            case TabEnum.CURRENCY:
                                headerValues = currencyHeaders;
                                break;
                            case TabEnum.ENHANCEDLANDFAVAILABILITY:
                                headerValues = enhancedLandFHeaders;
                                break;
                        }

                        const excelHeaders = [];
                        const range = XLSX.utils.decode_range(ws['!ref']);
                        for (let C = range.s.c; C <= range.e.c; ++C) {
                            const cell_address = { c: C, r: 0 }; // Assuming headers are in the first row
                            const header = XLSX.utils.encode_cell(cell_address);
                            if (ws[header]) {
                                var key = headerValues.find(x => x.header.trim().toLowerCase() === ws[header]?.v.trim().toLowerCase());
                                if (key) {
                                    excelHeaders.push(key.header);
                                }
                                else {
                                    excelHeaders.push(ws[header].v);
                                }
                            }
                        }
                        if (value === TabEnum.SERVICEDISTRIBUTION) {

                            filedata.forEach((obj) => {
                                let rowobject = {};
                                Object.keys(obj).map((item) => {

                                    var key = headerValues.find(x => x.header === item);
                                    if (key) {
                                        rowobject[key.id] = obj[key.header];
                                    }
                                    else {
                                        let id = toVariableNameFormat(item);
                                        rowobject[id] = obj[item];
                                    }
                                });
                                objArr.push(rowobject);
                            });
                        }
                        else {
                            filedata.forEach((obj) => {
                                let rowobject = {};
                                Object.keys(obj).map((item) => {
                                    var key = headerValues.find(x => x.header.trim().toLowerCase() === item.trim().toLowerCase());
                                    if (key) {
                                        rowobject[key.id] = obj[item];
                                    }
                                });
                                objArr.push(rowobject);
                            });
                        }

                        var columnheaders = headerValues.map(x => x.header).every(item => excelHeaders.includes(item))

            if(!columnheaders)
            {
              let invalid=excelHeaders?.filter(item => !headerValues.map(x=>x.header).includes(item));
              let message=` ${Constants.INVALIDHEADERERROR} [${invalid.join(", ")}]. ${Constants.REFERTEMPLATE}`;
              setNotificationMsg(message);
              setNotificationSeverity(Severity.ERROR);
              setShowNotification(true);
              setLoadingState(false);
              return false;
            }
            if (objArr.length === 0) {
              setNotificationMsg(Constants.EMPTYFILEERROR);
              setNotificationSeverity(Severity.INFO);
              setShowNotification(true);
              setLoadingState(false);
            } else {
              switch (value) {
                case TabEnum.SESSIONUSAGEPERCASE:
                  SaveSessionUsageMaster(objArr);
                  break;
                case TabEnum.STAFFTIME:
                  SaveStaffTimeMasterData(objArr);
                  break;
                case TabEnum.STAFFPRODUCTIVITY:
                  SaveStaffProductivityMasterData(objArr);
                  break;
                case TabEnum.STAFFCOST:
                  SaveStaffCostDepartmentMasterData(objArr);
                  break;
                case TabEnum.SERVICEDISTRIBUTION:
                  SaveServiceDistributionMasterData(objArr,headerValues);
                  break;
                case TabEnum.EXTERNALCOST:
                  SaveExternalCostsMasterData(objArr);
                  break;
                case TabEnum.OVERHEADCOST:
                  SaveOverHeadCostsMasterData(objArr);
                  break;
                case TabEnum.WEBCOST:
                  SaveWebCostMasterData(objArr);
                  break;
                case TabEnum.MARGINTABLE:
                  SaveProductMarginMasterData(objArr);
                  break;
                case TabEnum.RRCIANDTRAININGPRICING:
                  SaveRricAndTrainingMasterData(objArr);
                  break;
                case TabEnum.ADDITIONALCOUNSELINGPRICING:
                  SaveAdditionalCounselingMasterData(objArr);
                  break;
                case TabEnum.PATHWAYSPRICING:
                  SavePathwayMasterData(objArr);
                  break;
                case TabEnum.GWQPRICING:
                  SaveGwqMasterData(objArr);
                  break;
                case TabEnum.NPRTWPRICING:
                  SaveNprtwMasterData(objArr);
                  break;
                case TabEnum.CURRENCY:
                  SaveCurrencyMasterData(objArr);
                  break;
                case TabEnum.ENHANCEDLANDFAVAILABILITY:
                  SaveEnhancedLandFAvailabilityMasterData(objArr);
                  break;

                                default:
                                    setNotificationMsg(Constants.INVALIDDATA);
                                    setNotificationSeverity(Severity.ERROR);
                                    setShowNotification(true);
                                    setLoadingState(false);
                                    break;
                            }
                        }
                    }
                } catch (error) {
                    setNotificationMsg(Constants.INVALIDFILE);
                    setNotificationSeverity(Severity.ERROR);
                    setShowNotification(true);
                    setUploadedFileType(null);
                    setShowConfirmationBox(false);
                    setConfirmationMessage("");
                    setUploadedFile(null);
                    setLoadingState(false);
                }
            } else {
                setNotificationMsg(Constants.WRONGFILETYPE);
                setNotificationSeverity(Severity.ERROR);
                setShowNotification(true);
                setLoadingState(false);
                setUploadedFileType(null);
                setShowConfirmationBox(false);
                setConfirmationMessage("");
                setUploadedFile(null);
            }
        }
    };
    //#endregion

    return (
        <ManageDataWrapper>
            <Banner
                Heading={Constants.BANNER_HEADING}
                Paragraph={Constants.BANNER_PARAGRAPH}
                showBreadcrumb={true}
                breadcrumbName={Constants.BREADCRUMB_NAME}
            />
            {hasError && <div>{Constants.ERRORMESSAGE}</div>}
            {!hasError && (
                <Container maxWidth="xl">
                    <TabPannel
                        value={value}
                        handleChange={handleChange}
                        tabs={DataTabs}
                        tabContents={tabContents}
                    />
                    {value === TabEnum.SESSIONUSAGEPERCASE && (
                        <Box className="boxWrapper">
                            <Box className="tabWrapper">
                                <Box className="tableWrapper">
                                    <div className="buttonTab">
                                        <SearchBoxSection
                                            handleUpload={handleConfirmUpload}
                                            handleDownloadData={handleFileDownload}
                                            handleDownloadTemplate={handleTemplateDownload}
                                            headers={sessionUsageHeader}
                                            data={sessionRowData}
                                        />
                                    </div>
                                    <DisplayTable
                                        headers={sessionUsageHeader}
                                        rows={sessionRowData}
                                        loading={loadingState}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    )}
                    {value === TabEnum.STAFFTIME && (
                        <TableTab
                            reload={renderKey}
                            handleUpload={handleConfirmUpload}
                            handleDownloadData={handleFileDownload}
                            handleDownloadTemplate={handleTemplateDownload}
                            headers={staffTimeHeaders}
                            Tab={value}
                        />
                    )}
                    {value === TabEnum.STAFFPRODUCTIVITY && (
                        <TableTab
                            reload={renderKey}
                            handleUpload={handleConfirmUpload}
                            handleDownloadData={handleFileDownload}
                            handleDownloadTemplate={handleTemplateDownload}
                            headers={staffProductivityHeaders}
                            Tab={value}
                        />
                    )}
                    {value === TabEnum.STAFFCOST && (
                        <TableTab
                            reload={renderKey}
                            handleUpload={handleConfirmUpload}
                            handleDownloadData={handleFileDownload}
                            handleDownloadTemplate={handleTemplateDownload}
                            headers={staffCostDepartmentHeaders}
                            Tab={value}
                        />
                    )}
                    {value === TabEnum.SERVICEDISTRIBUTION && (
                        <TableTab
                            reload={renderKey}
                            handleUpload={handleConfirmUpload}
                            handleDownloadData={handleFileDownload}
                            handleDownloadTemplate={handleTemplateDownload}
                            Tab={value}
                            headers={serviceDistributionHeaders}
                        />
                    )}
                    {value === TabEnum.EXTERNALCOST && (
                        <TableTab
                            reload={renderKey}
                            handleUpload={handleConfirmUpload}
                            handleDownloadData={handleFileDownload}
                            handleDownloadTemplate={handleTemplateDownload}
                            Tab={value}
                            headers={externalCostHeaders}
                        />
                    )}
                    {value === TabEnum.OVERHEADCOST && (
                        <TableTab
                            reload={renderKey}
                            handleUpload={handleConfirmUpload}
                            handleDownloadData={handleFileDownload}
                            handleDownloadTemplate={handleTemplateDownload}
                            Tab={value}
                            headers={overHeadCostHeaders}
                        />
                    )}
                    {value === TabEnum.WEBCOST && (
                        <TableTab
                            reload={renderKey}
                            handleUpload={handleConfirmUpload}
                            handleDownloadData={handleFileDownload}
                            handleDownloadTemplate={handleTemplateDownload}
                            Tab={value}
                            headers={webCostHeaders}
                        />
                    )}
                    {value === TabEnum.MARGINTABLE && (
                        <TableTab
                            reload={renderKey}
                            handleUpload={handleConfirmUpload}
                            handleDownloadData={handleFileDownload}
                            handleDownloadTemplate={handleTemplateDownload}
                            Tab={value}
                            headers={marginTableHeaders}
                        />
                    )}
                    {value === TabEnum.PRODUCTPRICINGMODELS && (
                        <PricingModels
                            reload={renderKey}
                            handleUpload={handleConfirmUpload}
                            handleDownloadData={handleFileDownload}
                            handleDownloadTemplate={handleTemplateDownload}
                            Tab={value}
                            headers={pricingModelsHeaders}
                        />
                    )}
                    {value === TabEnum.RRCIANDTRAININGPRICING && (
                        <TableTab
                            reload={renderKey}
                            handleUpload={handleConfirmUpload}
                            handleDownloadData={handleFileDownload}
                            handleDownloadTemplate={handleTemplateDownload}
                            Tab={value}
                            headers={rrciAndTrainingHeaders}
                        />
                    )}
                    {value === TabEnum.ADDITIONALCOUNSELINGPRICING && (
                        <TableTab
                            reload={renderKey}
                            handleUpload={handleConfirmUpload}
                            handleDownloadData={handleFileDownload}
                            handleDownloadTemplate={handleTemplateDownload}
                            Tab={value}
                            headers={additionalCounselingHeaders}
                        />
                    )}
                    {value === TabEnum.PATHWAYSPRICING && (
                        <TableTab
                            reload={renderKey}
                            handleUpload={handleConfirmUpload}
                            handleDownloadData={handleFileDownload}
                            handleDownloadTemplate={handleTemplateDownload}
                            Tab={value}
                            headers={pathWayHeaders}
                        />
                    )}
                    {value === TabEnum.GWQPRICING && (
                        <TableTab
                            reload={renderKey}
                            handleUpload={handleConfirmUpload}
                            handleDownloadData={handleFileDownload}
                            handleDownloadTemplate={handleTemplateDownload}
                            Tab={value}
                            headers={gwqHeaders}
                        />
                    )}
                    {value === TabEnum.NPRTWPRICING && (
                        <TableTab
                            reload={renderKey}
                            handleUpload={handleConfirmUpload}
                            handleDownloadData={handleFileDownload}
                            handleDownloadTemplate={handleTemplateDownload}
                            Tab={value}
                            headers={nprwtHeaders}
                        />
                    )}
                    {value === TabEnum.CURRENCY && (
                        <TableTab
                            reload={renderKey}
                            handleUpload={handleConfirmUpload}
                            handleDownloadData={handleFileDownload}
                            Tab={value}
                            handleDownloadTemplate={handleTemplateDownload}
                            headers={currencyHeaders}
                        />
                    )}
                    {value === TabEnum.ENHANCEDLANDFAVAILABILITY && (
                        <TableTab
                            reload={renderKey}
                            handleUpload={handleConfirmUpload}
                            handleDownloadData={handleFileDownload}
                            Tab={value}
                            handleDownloadTemplate={handleTemplateDownload}
                            headers={enhancedLandFHeaders}
                        />
                    )}
                </Container>
            )}
            {showNotification && (
                <Notification
                    open={showNotification}
                    onClose={closeNotificationPopup}
                    message={notificationMsg}
                    severity={notificationSeverity}
                />
            )}
            {showConfirmationBox && (
                <ConfirmationBox
                    show={showConfirmationBox}
                    title={Constants.CONFIRM}
                    message={confirmationMessage}
                    showDownload={showInvalidDownload}
                    handleCancelClick={closeConfirmationBox}
                    handleConfirmClick={handleFileUpload}
                    handleDownload={handleRejectedListDownload}
                />
            )}
            {loadingState && <Loader open={loadingState} />}
        </ManageDataWrapper>
    );
};

export default ManageData;
